import { Map } from 'immutable';

import { getCharactersCountError, getInstructionsError, validatePersonalization } from '../validations/personalization';
import { clearErrors, setErrors } from '../errors';
import { getSize } from '../iterable/getSize';

import { ENABLED, OPERATIONS, PERSONALIZATION_ERRORS, REQUIRED, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { EMPTY } from '../../constants';

export function editPersonalization({ product: source, ...values }) {
  let errors = EMPTY.MAP;
  let product = source;
  const operations = [];
  const channel = product.get('channel');

  if (ENABLED in values) {
    const enabled = values[ENABLED];
    product = product.setIn([ATTRIBUTE.PERSONALIZATION, ENABLED], enabled);
    operations.push(
      Map({ type: OPERATIONS[channel].PERSONALIZATION.IS_PERSONALIZABLE_SET, value: enabled })
    );

    if (enabled) {
      errors = validatePersonalization({ channel, personalization: product.get(ATTRIBUTE.PERSONALIZATION) });

      if (!errors.size) {
        product = clearErrors({
          errors: PERSONALIZATION_ERRORS,
          path: ATTRIBUTE.PERSONALIZATION,
          product,
        });
      }
    } else {
      product = clearErrors({
        errors: PERSONALIZATION_ERRORS,
        path: ATTRIBUTE.PERSONALIZATION,
        product,
      });
    }
  }

  if (REQUIRED in values) {
    const required = values[REQUIRED];
    product = product.setIn([ATTRIBUTE.PERSONALIZATION, REQUIRED], required);
    operations.push(
      Map({ type: OPERATIONS[channel].PERSONALIZATION.IS_REQUIRED_SET, value: required })
    );
  }

  if (ATTRIBUTE.CHAR_COUNT_MAX in values) {
    const charCountMax = values[ATTRIBUTE.CHAR_COUNT_MAX];
    const error = getCharactersCountError({ channel, value: charCountMax });
    product = product.setIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.CHAR_COUNT_MAX, VALUE], charCountMax);

    if (error) {
      errors = errors.set(ATTRIBUTE.CHAR_COUNT_MAX, error);
    } else {
      product = clearErrors({ errors: [ATTRIBUTE.CHAR_COUNT_MAX], path: ATTRIBUTE.PERSONALIZATION, product });
      operations.push(
        Map({ type: OPERATIONS[channel].PERSONALIZATION.CHAR_COUNT_MAX_SET, value: charCountMax })
      );
    }
  }

  if (ATTRIBUTE.INSTRUCTIONS in values) {
    const instructions = values[ATTRIBUTE.INSTRUCTIONS];
    const error = getInstructionsError({ channel, value: instructions });
    product = product.setIn([ATTRIBUTE.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE], instructions);

    if (error) {
      errors = errors.set(ATTRIBUTE.INSTRUCTIONS, error);
    } else {
      product = clearErrors({ errors: [ATTRIBUTE.INSTRUCTIONS], path: ATTRIBUTE.PERSONALIZATION, product });
      operations.push(
        Map({ type: OPERATIONS[channel].PERSONALIZATION.INSTRUCTIONS_SET, value: instructions })
      );
    }
  }

  if (getSize(errors) > 0) {
    product = setErrors({ errors, path: ATTRIBUTE.PERSONALIZATION, product });
  }

  return { product, operations };
}
